'use strict';

angular.module('licensure.services')
    .factory('Complaints', ['$http', '$q', function ($http, $q) {
        return {
             getFilter: function (filter, timeout) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Complaints/getFilter', filter, {
                    timeout: (timeout != null ? timeout.promise : null)
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getCount: function (filter, timeout) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Complaints/getCount', filter, {
                    timeout: (timeout != null ? timeout.promise : null)
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Complaints/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getByUserID: function(user_id, detail, enterprise_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Complaints/getByUserID', {
                    params: {
                        user_id: user_id,
                        detail: detail,
                        enterprise_id: enterprise_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/InvestigationsModule/Investigation/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            bulkAction: function (complaintIDs, value, code) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Complaints/bulkAction', {
                    complaintIDs: complaintIDs,
                    value: value,
                    code: code
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            checkCategoryAutoNumber: function (categoryId) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/complaints/categoryAutoNumber/' + categoryId, {
                    params: {
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            printInvestigation: function (printInvestigationModel) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/InvestigationsModule/Investigation/print', {
                    params: printInvestigationModel
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;